interface VerifyLoginITF {
  appId: any;
  token: string;
  requestId: string;
  authRequestId: string;
}

export const verifyLogin = async (payload: VerifyLoginITF) => {
  // use to verify login on verifier apps e.g: Exchange. (Note: triggered when allowing authorization request)
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/chain/verify-login`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};
